// extracted by mini-css-extract-plugin
export default {"root":"B6_EhG"};